import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';

import { AuthService } from 'src/app/models/auth/_services/auth.service';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config.service';
import { Favorite } from 'src/app/models/auth/_models/favorite';
import { LayoutComponentService } from 'src/app/services/layout-component.service';
import { MainHTTPService } from 'src/app/services/main-http/main-http.service';
import { FavoritesService } from 'src/app/services/favorites.service';
import { DxTreeViewComponent, DxTreeViewModule } from 'devextreme-angular';
import {
  CommonService,
  MessagesService,

  PageService,

  SpinnerService
} from '../../../services/service.index';
import { MicroapplicationService } from 'src/app/services/microapplications/_services/microapplication.service';
import { ResourceParameter } from 'src/app/services/microapplications/_models/resource-parameter.model';
import { Page } from 'src/app/models/page.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
@Component({
  selector: 'app-favorites',
  templateUrl: './favorites.component.html',
  styleUrls: ['./favorites.component.scss']
})
export class FavoritesComponent implements OnInit {
  favorites: Favorite[] = [];
  @ViewChild(DxTreeViewComponent) treeView: DxTreeViewComponent;
  tokeshistori: string;
  codigoForm: string;
  html: SafeResourceUrl;
  public listHistorial = JSON.parse(
    sessionStorage.getItem('listHisotrial') || '[]'
  );
  url: BehaviorSubject<SafeResourceUrl> = new BehaviorSubject<SafeResourceUrl>('');

  pagesSe: Page[] = [];


  constructor(private layoutManager: LayoutComponentService, private router: Router,
    private favoritesService: FavoritesService,   private _pageService: PageService, private _commonService: CommonService,  private sanitizer: DomSanitizer,private microapps: MicroapplicationService,  private _messagesService: MessagesService, private _spinnerService: SpinnerService, private mainHttpService: MainHTTPService,private auth:AuthService) { }

  ngOnInit(): void {

    this.favoritesService.getFavorites(Number(this.auth.currentUserValue.selectedCompany.code));
    this.favoritesService.favorites$.subscribe(favorites => {
      if(favorites!=null){
        this.favorites = favorites;
        this.getMainInformation();
      }
      
    })

  }


  getMainInformation() {
    for (let favorite of this.favorites) {
      this.mainHttpService.getMainMenu(favorite.fav_maid).subscribe(menuResult => {
        if (menuResult.isSuccessful && menuResult.result != null) {
          favorite.text = menuResult.result.text,
            favorite.id = menuResult.result.id
        }
      })
    }

  }
  // openMicroApp(itemObj: Favorite) {
  //   if (this.router.url == "/multiview") {
  //     this.layoutManager.layoutManagerAction.next({ id: itemObj.fav_maid, name: itemObj.text })
  //   }
  //   else {
  //     this.router.navigate(['/multiview']).then(() => {
  //       setTimeout(() => {
  //         this.layoutManager.layoutManagerAction.next({ id: itemObj.fav_maid, name: itemObj.text })
  //       }, 1000);

  //     })
  //   }
  // }


  
  openMicroApp(itemObj: any) {


    this._spinnerService.loading();
    if (!itemObj.fav_maid) {

      this._messagesService.error('Programa no autorizado para usuario');
      this._spinnerService.close();
      return;
    }


    this.microapps.GetMicroApplicationsById(itemObj.fav_maid).subscribe((microApp) => {
      if (microApp.isSuccessful) {
        let url = `${microApp.result.url}?`;
        // this.data=microApp;

        this.tokeshistori = this.auth.getAuthFromLocalStorage().accessToken;
        this.codigoForm = microApp.result.code;
        if (microApp.result.parameters != null) {
          let i = 0;
          for (const parameter of microApp.result.parameters) {

            url += `${i === 0 ? '' : '&'}${parameter.code}=${this.GetGlobalVariables(parameter)}`;
            i += 1;
          }

          this.html = url;

          /*
 * URL obtenida del catálogo interno de microaplicaciones.
 * Se valida previamente el origen y no proviene de entrada
 * controlada por el usuario.
 */

          this.url.next(this.sanitizer.bypassSecurityTrustResourceUrl(url));
          this.html = this.sanitizer.bypassSecurityTrustResourceUrl(url)
          this.pagesSe.length = 0;
          this.pagesSe.push({
            codProg: itemObj.fav_cont,
            name:  itemObj.text,
            idForm: itemObj.fav_maid,
            id: itemObj.id,
            url: url,
            cambiarUrl: true,
            // typeForm: itemObj.url.includes('adpro') ? 'adpro' : 'maestro'
            typeForm: 'maestro',
            lisnk:null
          })

          const page: Page = {
            codProg: itemObj.fav_cont,
            name: itemObj.text,
            idForm: itemObj.fav_maid,
            id: itemObj.id,
            url: null,
            cambiarUrl: true,
            // typeForm: itemObj.url.includes('adpro') ? 'adpro' : 'maestro'
            typeForm: 'maestro',
            lisnk:null
          };
          this.removeClass('open-item');
          this._spinnerService.close();

          page.url = url;

          this._commonService.setItemsessionStorage('Pages', this.pagesSe);
          this.router.navigate(['/pageTabPanel']);
          // // Cerrar el menú lateral en versiones móviles
          // if (this.isMobile) {
          //   const event: MouseEvent = new MouseEvent('click');
          //   this.CloseMenu();
          // }
          this.addHistorial(page);
          this._pageService.generarPage(page)
       



        }
      }
    }, err => {

      this._messagesService.error('Error conectando con servicio de microaplicaciones');
    });



  }
  removeClass = (classs: string) => {
    let nodes = document.querySelectorAll(`.${classs}`);
    nodes.forEach(node => {
      node.classList.remove(classs)
    })
  }
  addHistorial(node: any) {
   
    let index = this.listHistorial.findIndex(
      (e: any) => e.idForm == node.idForm
      
    );
    if (index != -1) {
      this.listHistorial.splice(index, 1);
      this.listHistorial.push(node);
    } else {
      this.listHistorial.push(node);
    }

    if (this.listHistorial.length > 3) {
      this.listHistorial = this.listHistorial.slice(
        this.listHistorial.length - 3
      );
    }
    sessionStorage.setItem('listHisotrial', JSON.stringify(this.listHistorial));
  }

  GetGlobalVariables(param: ResourceParameter) {
    if (param.type == 0) {
      return param.value;
    } else {
      switch (param.code) {
        case "token":
          return this.auth.getAuthFromLocalStorage().accessToken;
        case "companyCode":
          return this.auth.currentUserValue.selectedCompany.code;
      }
    } return null
  }
  // itemClick(e) {    

  //   let mainItem  = e.itemData;  
  //   this.favoritesService.deleteFavorite(mainItem.id);

  // }

  itemClick(e) {

     let mainItem  = e.itemData;  
    this.favoritesService.deleteFavorite(mainItem.id);


  }

}
